import { interactionModelReducer } from './slice'

export const interactionModel = interactionModelReducer

export default interactionModelReducer
